import { Injectable } from '@angular/core';
import { Drivers } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { TSaveEventHubInfo, TSaveEventEventHub, TREQUEST_SAVE_EVENT } from '@monorepo/types';
import { v4 as uuidv4 } from 'uuid';

type TMessageHeader = {
  'Content-Type': 'application/json';
};

let __EVENT_SEQ_ID__ = 1;

export type TSaveEventSubset = Pick<
  TREQUEST_SAVE_EVENT,
  'subject_key' | 'server_validation' | 'wipType' | 'qty_validation'
>;

export type TNetworkStoreageDB = {
  [k: string]: {
    id: '1663436311295-684' | string; // Done
    url: 'https://nfactorylive.ncinga.com/event_hub/ext/api/v3/event/save' | string;
    method: 'POST'; // Done
    message_type: 'event'; // Done
    message_header: TMessageHeader; // Done
    message: TSaveEventEventHub;
    status: 'fail' | 'in-progress';
    save_time: number;
    last_update_time: number;
  } & TSaveEventSubset;
};

@Injectable({
  providedIn: 'root',
})
export class NetworkStorageDbService {
  #storage = new Storage({
    name: '___network_cache_db',
    driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
  });

  async init() {
    this.#storage.create();
  }

  async get(key: string): Promise<TNetworkStoreageDB[string]> {
    const storage = await this.#storage?.get(key);
    return storage;
  }

  async getAllKeyValuesList(): Promise<TNetworkStoreageDB[string][]> {
    const eventsList = [] as TNetworkStoreageDB[string][];
    await this.#storage?.forEach((v) => {
      // console.log('GetAll kEys', v);
      eventsList.push(v);
    });
    console.log('GetAll kEyes', eventsList);
    return eventsList;
  }

  async remove(key: string): Promise<TNetworkStoreageDB[string]> {
    const storage = await this.#storage?.remove(key);
    return storage;
  }

  private getEventInfo(): [v_id: string, eventId: string, eventInfo: TSaveEventEventHub['ei'], timeZoneOffest: number] {
    __EVENT_SEQ_ID__ = __EVENT_SEQ_ID__ + 1;
    const currentDate = new Date();
    const eventInfo: TSaveEventEventHub['ei'] = {
      dt: currentDate.getTime(),
      id: __EVENT_SEQ_ID__,
    };
    const eventId = eventInfo.dt + '-' + eventInfo.id;
    const v_id = eventInfo.dt + '_' + uuidv4();
    const timeZoneOffest = currentDate.getTimezoneOffset();
    return [v_id, eventId, eventInfo, timeZoneOffest];
  }

  async save(
    saveEventHubInfo: TSaveEventHubInfo,
    eventSubset: TSaveEventSubset,
    status: TNetworkStoreageDB[string]['status'],
  ) {
    const [v_id, eventId, eventInfo, timeZoneOffest] = this.getEventInfo();
    const saveEventInfo: TNetworkStoreageDB[string] = {
      id: eventId,
      url: 'https://nfactorylive.ncinga.com/event_hub/ext/api/v3/event/save',
      method: 'POST', // Done
      message_type: 'event', // Done
      message_header: {
        'Content-Type': 'application/json',
      },
      save_time: eventInfo.dt,
      last_update_time: eventInfo.dt,
      message: {
        v_id: v_id,
        ei: eventInfo,
        w1: {
          dt: eventInfo.dt,
          os: timeZoneOffest,
          tz: 'Asia/Colombo',
          cc: {
            i: eventInfo.dt,
            o: eventInfo.dt,
          },
        },
        ...saveEventHubInfo,
      },
      status,
      ...eventSubset,
    };
    const key = saveEventInfo.message.ei.dt.toString() + '-' + saveEventInfo.message.ei.id.toString();
    const storage = await this.#storage?.set(key, saveEventInfo);
    return storage as TNetworkStoreageDB[string];
  }
}
